
import { Vue, Component, toNative } from 'vue-facing-decorator';
import GroupSelections from '@/components/Participants/Groups/GroupSelections/GroupSelections.vue';
import { Root } from '@/main';

@Component({
  components: { GroupSelections },
})
class Participants extends Vue {
  private mounted() {
    Root.emit('set-active-component', 'participants');
  }
}
export default toNative(Participants);
